"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "scopeAppropriateImage", {
  enumerable: true,
  get: function get() {
    return _scopeAppropriateImage.scopeAppropriateImage;
  }
});

var _scopeAppropriateImage = require("./scope-appropriate-image");